export const CACHE_EXPIRATION_HOURS_CONSTANTS = 24;
export const CACHE_KEY_PREFIX_CONSTANTS = 'insurance_notification_';
export const ACCEPTED_BY_PLATFORM_WEB_CONSTANTS = 'platform-web';
